import { useEffect, useLayoutEffect, useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom';

const makeSubscribed = <T>(initialValue: T) => {
  type Subscriber = (v: T) => void;

  let value = initialValue;
  let subscribers: Subscriber[] = [];

  const get = () => value;
  const set = (v: T) => {
    value = v;
    for (const sub of subscribers) {
      sub(v);
    }
  };
  const subscribe = (s: Subscriber) => {
    subscribers.push(s);
  };
  const unsubscribe = (s: Subscriber) => {
    subscribers = subscribers.filter((sub) => sub !== s);
  };
  return { get, set, subscribe, unsubscribe };
};

const startupSub = makeSubscribed<null | NodeJS.Timer>(null);
const currentProbeSub = makeSubscribed<null | NodeJS.Timer>(null);


export interface YandexIndexerContext {
  /** Использовать, если нужно вручную сообщить, что контент загружен */
  loaded: () => void
  /** Сбросить настройки до состояния незагруженной страницы */
  setUnloaded: () => void
}

export const useYandexIndexer = (isManual = false) => {
  const [startupTimer, setStartupTimer] = useState<null | NodeJS.Timer>(null)
  const [currentProbeTimer, setCurrentProbeTimer] = useState<null | NodeJS.Timer>(null)

  const subStartup = () => {
    if (startupTimer) {
      clearTimeout(startupTimer)
    }
    setStartupTimer(null);
    startupSub.unsubscribe(subStartup)
  }
  const probeSub = () => {
    if (currentProbeTimer) {
      clearTimeout(currentProbeTimer)
    }
    setCurrentProbeTimer(null)
    currentProbeSub.unsubscribe(probeSub)
  }
  startupSub.subscribe(subStartup);
  currentProbeSub.subscribe(probeSub);

  const location = useLocation();

  const loaded = useCallback(() => {
    if (startupSub.get()) {
      // console.log('Trying to stop');
      currentProbeSub.set(setTimeout(() => {
        currentProbeSub.set(null)
        loaded();
      }, 1_000))
      // console.log(startupSub.get(), currentProbeSub.get());
      setCurrentProbeTimer(currentProbeSub.get());
      return;
    }
    currentProbeSub.set(null);
    startupSub.set(null);
    window.YandexRotorSettings = {
      IsLoaded: true,
    };
    // console.log('Stopped');
  }, []);

  const setUnloaded = useCallback(() => {
    startupSub.set(null);
    currentProbeSub.set(null);
    window.YandexRotorSettings = {
      WaiterEnabled: true,
      FailOnTimeout: false,
      NoJsRedirectsToMain: true
    };
    startupSub.set(setTimeout(() => {
      startupSub.set(null);
      // console.log('Startup timer destroyed');
    }, 10_000));
    
    setStartupTimer(startupSub.get());
    // console.log('Reset');
  }, []);

  useLayoutEffect(() => {
    window.YandexRotorSettings = {
      WaiterEnabled: true,
      FailOnTimeout: false,
      NoJsRedirectsToMain: true
    };
    // console.log('Setting up startup timer');

    startupSub.set(setTimeout(() => {
      startupSub.set(null);
      // console.log('Startup timer destroyed');
    }, 10_000))
    
    setStartupTimer(startupSub.get());
  }, [location.pathname]);

  useEffect(() => {
    if (isManual) {
      return;
    }
    loaded();
  }, [location.pathname, isManual, loaded]);

  return {
    loaded,
    setUnloaded
  } as YandexIndexerContext;
}

export const emptyIndexerContext: YandexIndexerContext = {
  loaded: () => { },
  setUnloaded: () => { }
};
